import { Component, Inject, Input, OnInit } from '@angular/core';
import { Report } from '../../../../../models/report';
import { DOCUMENT } from '@angular/common';
import { DssReports } from '../../../../../models/dss-reports';
import { environment } from '../../../../../../environments/environment';
import { ReportMessages } from '../../../../shared/models/component-messages/report-messages';
import { DownloaderMessages } from '../../../../shared/models/component-messages/downloader-messages';

@Component({
  selector: 'app-report',
  templateUrl: './report.component.html',
  styleUrls: ['./report.component.scss']
})
export class ReportComponent implements OnInit {
  @Input() title;
  @Input() report: Report;
  @Input() reports: DssReports;
  @Input() reportType: string;
  @Input() fileName: string;
  @Input() originalFileName: string;
  public size = 0;
  public tsize = 0;
  public profile: boolean;
  public reportMessages = new ReportMessages();
  public downloaderMessages = new DownloaderMessages();

  constructor(@Inject(DOCUMENT) private document: Document) {
  }

  ngOnInit() {
    this.profile = (environment.profile === 'tst' || environment.profile === 'dev') ;
    if (this.report) {
      this.size = this.report.xmlReport.signatures.length;
      if (this.size === 0) {
        this.tsize = this.report.xmlReport.timeStamps.length;
      }
    }
  }
}
